<template>
   <div class="">
      <h4 :class="titleClass" class="f-18 mb-4">{{ title }}</h4>
      <div class="gap-3">
         <div class="mb-3 text-start">
            <!-- <label for="ownerName" class="form-label fw-medium">
               Owner Name
            </label>
            <div class="form-group">
               <input v-model="card_user_name" id="ownerName" type="text" name="card-owner_name" required
                  class="form-control form-label" placeholder="Card Owner Name" />
            </div> -->
            <div class="form-group">
               <input id="ownerName" type="text" class="form-control light-bg fs-14 rounded-pill px-4" placeholder=""
                  v-model="card_user_name" autocomplete="card_user_name" />
               <label for="ownerName" class="gray-text fs-14 px-2 card-ownername light-bg">Card Owner Name </label>
            </div>
         </div>
         <div class="mb-3 text-start">
            <!-- <label class="form-label fw-medium">
               Card#
            </label> -->
            <stripe ref="stripe_component"></stripe>
         </div>
      </div>
   </div>
</template>

<script>
import stripe from '@/components/Stripe';
export default {
   name: "StripePaymentMethod",

   components: {
      stripe,
   },



   props: {
      title: {
         type: String,
         default: 'Payment Details'
      },

      titleClass: {
         type: String,
         default: 'f-18'
      },


   },

   data() {
      return {
         card_user_name: null,
      }
   },

   methods: {
      async getPaymentMethodId() {
         try {

            const { paymentMethod, error } = await this.$refs.stripe_component
               .stripe.createPaymentMethod(
                  {
                     type: 'card',
                     card: this.$refs.stripe_component.card,
                     billing_details: { name: this.card_user_name }
                  }
               );

            if (error) {

               // console.log(error);
               // this.handleErrorResponse(error.message)
               this.triggerSwal(error.message, "error");
            } else {
               return paymentMethod.id;
            }
         } catch (e) {
            console.log(e);
            this.handleErrorResponse(e)
         }
      },
      emitCode() {
         this.$emit('couponId', this.coupon_id);
      }
   },
}
</script>

<style scoped>
.card-ownername {
   top: 12px !important;
}
</style>
